import { createContext } from 'react'

const contextPayload = {
  isPrivated: undefined,
  userType: undefined,
  sellerDni: undefined
}

const AuthorizationContext = createContext(contextPayload)
AuthorizationContext.displayName = 'authorization-context'

export default AuthorizationContext
